'use strict';

export const pluginPermissions = {
  displayPlugin: [{
    action: 'plugin::content-search.read',
    subject: null
  }]
};